export const REQUEST_LAWYER_ASSIGNED_CLAIMS = 'REQUEST_LAWYER_ASSIGNED_CLAIMS';

export const SET_LAWYER_ASSIGNED_CLAIMS = 'SET_LAWYER_ASSIGNED_CLAIMS';

export const REQUEST_LEGAL_PROCEEDINGS_STEPS =
  'REQUEST_LEGAL_PROCEEDINGS_STEPS';

export const SET_LEGAL_PROCEEDINGS_STEPS = 'SET_LAWYER_LEGAL_PROCEEDINGS_STEPS';

export const ASSIGNMENT_FIELDS = {
  CLAIM_NUMBER: 'claimNumber',
  CLAIM_NATURE: 'claimNature',
  REGISTRATION_NUMBER: 'registrationNumber',
  LOSS_DATE: 'lossDate',
  LOSS_HOUR: 'lossHour',
  LOSS_LOCATION: 'lossLocation',
  STATUS: 'status',
};

export const CLAIM_STATUS_TRANSLATE = {
  PROCES_VERBAL: 'procesVerbalStatus',
  PENDING: 'pending',
  VALIDATED: 'validated',
  REJECTED: 'rejected',
  TO_EDIT: 'toEdit',
  TO_COMPLETE: 'toComplete',
  MODIFIED: 'edited',
  VALIDATED_WITHOUT_CONTESTATION: 'validatedWithoutContestation',
  APPEL: 'appealStatus',
  OPPOSITION: 'opposition',
  APPLICATION_ANNULMENT: 'applicationAnnulment',
} as { [key: string]: string };

export const LAWYER_ASSIGNMENTS = {
  PROCES_VERBAL: 0,
  JUDGEMENT_ADD: 1,
  EXPERT_REPORT: 2,
  JUDGEMENT_ON_MERITS: 3,
  ARRET_ADD: 4,
  EXPERT_REPORT_APPEAL: 5,
  ARRET_ON_MERITS: 6,
};

export const LAWYER_ASSIGNMENTS_LABELS = [
  'PROCES_VERBAL',
  'JUDGEMENT_ADD',
  'EXPERT_REPORT',
  'JUDGEMENT_ON_MERITS',
  'JUDGEMENT_ADD',
  'EXPERT_REPORT',
  'JUDGEMENT_ON_MERITS',
];
